import React, { useState } from "react";
import { CustomImgPreviewModal } from "./Modals";

const CustomImageCard = ({ src, alt, width, height, imagePreview }) => {
  const [loaded, setLoaded] = useState(false);
  const [imgSrc, setImgSrc] = useState("");
  const [imgZoom, setImgZoom] = useState(false);

  const handleViewPreview = (img) => {
    setImgZoom(true);
    setImgSrc(img);
  };

  return (
    <div
      className="lms_custom_image_wrapper"
      style={{
        width: width || "auto",
        height: height || "auto",
        position: "relative",
      }}
    >
      {!loaded && <div className="lms_custom_image_loading" />}
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        loading="lazy"
        style={{
          height: "100%",
          objectFit: "cover",
          cursor: imagePreview ? "pointer" : "default",
        }}
        onClick={() => imagePreview && handleViewPreview(src)}
        onLoad={() => setLoaded(true)}
      />
      {imgZoom && (
        <CustomImgPreviewModal
          show={imgZoom}
          imgSrc={imgSrc}
          onHide={() => setImgZoom(!imgZoom)}
        />
      )}
    </div>
  );
};

export default React.memo(CustomImageCard);
